import React from 'react';

/** Aviso: equipamento com OS aberta nos últimos 30 dias (exibido após o aviso de contrato, se houver). */
export default function OpenOsV2RecentOsModal({ v }) {
  const modal = v && v.recentOsModal;
  if (!modal || (v && v.contratoVencModal)) return null;

  const quando =
    modal.dias === 0 ? 'hoje' : modal.dias === 1 ? 'há 1 dia' : `há ${modal.dias} dias`;

  return (
    <div
      className="oosv2-contrato-venc-overlay"
      role="dialog"
      aria-modal="true"
      aria-labelledby="oosv2-recent-os-title"
      onClick={v.closeRecentOsModal}
    >
      <div className="oosv2-contrato-venc-card" onClick={(e) => e.stopPropagation()}>
        <div className="oosv2-contrato-venc-icon" aria-hidden="true">!</div>
        <div id="oosv2-recent-os-title" className="oosv2-contrato-venc-title">
          OS recente neste equipamento
        </div>
        <div className="oosv2-contrato-venc-text">
          Este equipamento teve OS aberta nos últimos 30 dias: <strong>OS {modal.os}</strong>, aberta em{' '}
          <strong>{modal.dateLabel}</strong> ({quando}).
        </div>
        <button type="button" className="oosv2-contrato-venc-btn" onClick={v.closeRecentOsModal}>
          Entendi
        </button>
      </div>
    </div>
  );
}
